/**
 * @module WebUI/MobileApp_コンポーネント
 */
/* WebUI/MobileApp の状態を保持*/
const state = {
  /* 0. WebUI/MobileApp共通のState */
  appUserEnv: {
    isMobile: '',
    isPc: '',
    isBrowser: '',
    isMobileWeb: '',
    isMobileApp: '',
    isAndroidApp: '',
    isIosApp: '',
  },

  /* 2. WeBUIのみで保持するState */

  /* 3. MobileAppのみで保持するState */
  // IF02
  // ログイン方法が"パスコード・スマートフォンの生体認証を使う"場合のパスコードを保持
  // passodeBioAuthInfo: {
  //   passcode01: "",
  //   passcode02: "",
  // },
  // IF04
  deviceOs: '',
  nativeAppInfo: {
    // errorCode: "",
    nativeVersion: '',
    // loginMethod: "",
    deviceToken: '',
    isPushNotificationAvailable: '',
    isBiometricAuthAvailable: '',
    // isPasscodeAuthAvailable: "",
  },
  // IF05
  accountInfo: {
    userId: '',
    password: '',
    terminalInfo: '',
  },
  usedLoginInfo: {
    userId: '',
    password: '',
  },
  // IF10
  nativeError: {
    errorCode: '',
  },
  // IF11
  lifeCycleState: {
    errorCode: '',
    appState: '',
  },

  deviceTokenError: {
    errorCode: '',
  },
};

const getters = {
  getAppUserEnv(state) {
    return state.appUserEnv;
  },
  // IF02
  // getPasscode01(state) {
  //   return state.passodeBioAuthInfo.passcode01;
  // },
  // getPasscode02(state) {
  //   return state.passodeBioAuthInfo.passcode02;
  // },
  // IF04
  getDeviceOs(state) {
    return state.deviceOs;
  },
  getNativeVersion(state) {
    return state.nativeAppInfo.nativeVersion;
  },
  getDeviceToken(state) {
    return state.nativeAppInfo.deviceToken;
  },
  getIsPushNotificationAvailable(state) {
    return state.nativeAppInfo.isPushNotificationAvailable;
  },
  getIsBiometricAuthAvailable(state) {
    return state.nativeAppInfo.isBiometricAuthAvailable;
  },
  // IF05
  getUserId(state) {
    return state.accountInfo.userId;
  },
  getPassword(state) {
    return state.accountInfo.password;
  },
  getTerminalInfo(state) {
    return state.accountInfo.terminalInfo;
  },
  getUsedLoginData(state) {
    return state.usedLoginInfo;
  },
  // IF10
  getNativeError(state) {
    return state.nativeError;
  },
  // IF11
  getLifeCycleState(state) {
    return state.lifeCycleState;
  },

  getDeviceTokenError(state) {
    return state.deviceTokenError;
  },
};

const mutations = {
  setAppUserEnv(state, env) {
    state.appUserEnv.isMobile = env.isMobile;
    state.appUserEnv.isPc = env.isPc;
    state.appUserEnv.isBrowser = env.isBrowser;
    state.appUserEnv.isMobileWeb = env.isMobileWeb;
    state.appUserEnv.isMobileApp = env.isMobileApp;
    state.appUserEnv.isAndroidApp = env.isAndroidApp;
    state.appUserEnv.isIosApp = env.isIosApp;
  },
  // IF02
  // setPassodeBioAuthInfo(state, passcodes) {
  //   state.passodeBioAuthInfo.passcode01 = passcodes.passcode01;
  //   state.passodeBioAuthInfo.passcode02 = passcodes.passcode02;
  // },
  // IF04
  setDeviceOs(state, num) {
    state.deviceOs = num;
  },
  setNativeAppInfo(state, nativeAppInfo) {
    state.nativeAppInfo.nativeVersion = nativeAppInfo.nativeVersion;
    state.nativeAppInfo.deviceToken = nativeAppInfo.deviceToken;
    state.nativeAppInfo.isPushNotificationAvailable = nativeAppInfo.isPushNotificationAvailable;
    state.nativeAppInfo.isBiometricAuthAvailable = nativeAppInfo.isBiometricAuthAvailable;
  },
  // IF05
  setAccountInfo(state, accountInfo) {
    state.accountInfo.userId = accountInfo.userId;
    state.accountInfo.password = accountInfo.password;
    state.accountInfo.terminalInfo = accountInfo.terminalInfo;
  },
  // IF10
  setNativeError(state, error) {
    state.nativeErrorCode.errorCode = error.errorCode;
  },
  // IF11
  setLifeCycleState(state, appState) {
    state.lifeCycleState.errorCode = appState.errorCode;
    state.lifeCycleState.appState = appState.appState;
  },

  setDeviceTokenError(state, error) {
    state.deviceTokenError = error;
  },

  setUsedLoginData(state, data) {
    state.usedLoginInfo.userId = data.userId;
    state.usedLoginInfo.password = data.password;
  },
};

const actions = {};

const appInfo = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default appInfo;
